import * as React from "react";

import { cn } from "../../lib/utils.js";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** `glass` drops the field's own chrome so it sits transparently inside a glass well. */
  variant?: "default" | "glass";
}

// focus:border-brand-500 matters as much as the ring: without it the dark
// border-surface-200 stays put and paints a line BETWEEN the ring and the
// field, so the highlight reads as a detached second border rather than
// one edge. Same reason it is on Textarea, SelectField and PhoneInput.
const defaultField =
  "flex h-9 w-full rounded-md border border-surface-200 bg-surface-0 px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-surface-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-50";

// The glass well (login-glass-well) draws the frame and the focus ring, so the
// field itself stays transparent. login-glass-input also repairs browser autofill.
const glassField =
  "login-glass-input h-11 w-full border-0 bg-transparent px-[15px] text-[14.5px] text-[color:var(--ink)] placeholder:text-[color:var(--ink-3)] outline-none disabled:cursor-not-allowed disabled:opacity-50";

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => (
    <input
      type={type}
      className={cn(variant === "glass" ? glassField : defaultField, className)}
      ref={ref}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input };
